import classes from './PointForm.module.sass'
import { usePointForm } from './hooks/usePointForm'
import { PointItem } from './components/pointItem/PointItem'
import { CargoItemInterface, PointItemInterface } from '../../../types/interfaces'
import { SetStateAction } from 'react'


type Props = {
  addresses: boolean
  intercity: boolean
  topData: CargoItemInterface
  isRoute: boolean
  setTopData: React.Dispatch<SetStateAction<CargoItemInterface>>
  initialData?: PointItemInterface[]
}

export const PointForm = ({ addresses, topData, isRoute, intercity, setTopData, initialData }: Props) => {
  const {
    data,
    sortPoints,
    addPoint,
    removePoint,
    pointUp,
    pointDown,
    dragStartHandler,
    dragLeaveHandler,
    dragEndHandler,
    dragOverHandler,
    dropHandler,
    setData,
    handleFormBlur,
  } = usePointForm(addresses, topData, intercity, setTopData, initialData, isRoute)


  

  return (
    <div className={classes.Container}>
      {[...data].sort(sortPoints).map((el, index) => (
        <PointItem
          addresses={addresses}
          intercity={intercity}
          isRoute={isRoute}
          el={el}
          key={el.id}
          data={data}
          addPoint={addPoint}
          removePoint={removePoint}
          pointUp={pointUp}
          pointDown={pointDown}
          dragStartHandler={dragStartHandler}
          dragLeaveHandler={dragLeaveHandler}
          dragEndHandler={dragEndHandler}
          dragOverHandler={dragOverHandler}
          dropHandler={dropHandler}
          index={index}
          setData={setData}
          handleFormBlur={handleFormBlur}
          topData={topData}
          setTopData = {setTopData}
        />
      ))}
    </div>
  )
}
